<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="应付明细账"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="getDataFunc"
      @status-change="cellFun"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商名称">
          <customer  @restaurants='setSupplier' :state='params.TradeUnitName' :typeList="[2, 3]"/>
        </el-form-item>
        <!--<el-form-item label="查询类型">
          <el-select size="mini" v-model="params.Type" clearable>
            <el-option label="普通应付" :value="0" />
            <el-option label="预付" :value="1" />
            <el-option label="其它应付" :value="2" />
          </el-select>
        </el-form-item>-->
        <el-form-item label="对账周期">
          <el-select size="mini" v-model="params.Cycle" @change="cycleChange" clearable>
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期" v-if="!isMB">
          <range-picker :date="[params.DocDateStart,params.DocDateEnd]" @change="dateChange" />
        </el-form-item>
        <template v-else>
          <el-form-item label="对账日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
        </template>
        <el-form-item label="对账期间">
          <range-picker month :s-date="sDate" :e-date="eDate" :date="date" @change="monthChange" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          v-for="(item,index) in OutledgerdtsList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align='center'
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{row}">
            <div v-if="item.prop=='DocDate'" :style="{ textAlign: item.align }">
              {{$commonJs.toDateString(row.DocDate)}}
            </div>
            <div v-else-if="item.prop=='DocNo'" :style="{ textAlign: item.align }">
              <el-button type="text">{{ row.DocNo }}</el-button>
            </div>
            <div v-else :style="{ textAlign: item.align }">{{row[item.prop]}}</div>
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData='setOutledgerdtsList' :tableType='tableType'/>
    <supplier ref="supplier" selectable @select="setTradeunit" />

    <stock-dialog ref="stockDialog"  />
    <return-dialog ref="returnDialog"  />
    <cost-dialog ref="costDialog"  />
    <ocost-dialog ref="ocostDialog"  />
    <paydoc-dialog ref="paydocDialog"  />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import supplier from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

import stockDialog from "@/components/purchase/business/stock/editDialog"; //进货单
import returnDialog from "@/components/purchase/business/return/editDialog";//退货单
import costDialog from "@/components/fund/contactcash/cost/detailsDialog"; // 费用单
import ocostDialog from "@/components/fund/contactcash/ocost/detailsDialog";//其他应付单
import paydocDialog from "@/components/cashier/paydoc/detailsDialog";//付款单

export default {
  mixins: [listMixin],
  components: { 
    list, supplier,customer,customTableDialog,
    stockDialog,returnDialog,costDialog,ocostDialog,paydocDialog
   },
  data() {
    return {
      api: require("@/api/fund/paydoc").default,
      dpapi: require("@/api/ba/tradeUnit").default,
      params: {
        Type: null,
        DocDateStart: null,
        DocDateEnd: null,
        MonthStart: null,
        MonthEnd: null,
        TradeUnitId: null,
        TradeUnitName: "",
        Cycle: "",
      },
      supplierList:[],
      isMB: this.$store.state.isMB,
      tableType:'应付明细账动态列',
      setOutledgerdtsList: [
        {
          prop:'TradeUnitName',
          label:'供应商名称',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'DocDate',
          label:'日期',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'DpName',
          label:'部门',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'EmpName',
          label:'经办人',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'Remark',
          label:'备注',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'SrcVouTypeName',
          label:'单据类型',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'BusinessTypeName',
          label:'业务类型',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'DocNo',
          label:'单据编号',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'NeedAmount',
          label:'应付',
          isShow:true,
          width:'180px',
          align:'right'
        },
        {
          prop:'AlreadyAmount',
          label:'已付',
          isShow:true,
          width:'180px',
          align:'right'
        },
        {
          prop:'LeftAmount',
          label:'余额',
          isShow:true,
          width:'180px',
          align:'right'
        },
      ]
    };
  },
  computed: {
    // 过滤不需要显示的列
	  OutledgerdtsList: function () {
	    return this.setOutledgerdtsList.filter(function (item) {
		    return item.isShow;
	    })
	  },
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  mounted() {
    if(localStorage.getItem(this.tableType)){
      this.setOutledgerdtsList = JSON.parse(localStorage.getItem(this.tableType))
    }else{
      localStorage.setItem('应付明细账动态列',JSON.stringify(this.setOutledgerdtsList));
    }
    this.dpapi.list({}).then(res => {
      let list=[]
      res.Data.forEach(e => {
        list.push( { "value": e.Name, "Id": e.Id },)
      });
      this.supplierList=list
    })
  },
  methods: {
    /** 动态列弹框保存 */
    onSave(){
      this.setOutledgerdtsList = JSON.parse(localStorage.getItem(this.tableType))
      this.$message.success("保存成功");
    },
    onCustomTable(){
      this.$refs.customTableDialog.dialogVisible = true
    },
    saveColumn() {
      localStorage.setItem("SetColOutledgerdts",JSON.stringify(this.showColumn))
      this.visible = false;
      this.$message.success("保存成功");
    },
    setSupplier(data) {
          
          this.params.TradeUnitId = data.TradeUnitId;
          this.params.TradeUnitName = data.TradeUnitName;
    },
    handleSelect(item) {
        
        this.params.TradeUnitName=item.value
        this.params.TradeUnitId=item.Id
    },
    querySearchAsync(queryString, cb) {
        var supplierList = this.supplierList;
        var results = queryString ? supplierList.filter(this.createStateFilter(queryString)) : supplierList;
        cb(results);
    },
    createStateFilter(queryString) {
        return (state) => {
          if(state.value){
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          }
        };
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        if (!params.DocDateStart) params.DocDateStart = params.MonthStart;
        if (!params.DocDateEnd) params.DocDateEnd = params.MonthEnd;

        this.api.getListDetailPay(params).then((res) => resolve(res));
      });
    },
    openTradeunit() {
      this.$refs.supplier.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.CustomerId;
      this.params.TradeUnitName = data.CustomerFullName;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
    onExport1() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportDetail(this.params).then(() => {
        loading.close();
      });
    },
    onExport2() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportCollect(this.params).then(() => {
        loading.close();
      });
    },
    cellFun(row, column){
      if (column.property == "DocNo") {
        switch (row.SrcVouTypeName) {
          case "进货单":
            sessionStorage.setItem("check", "1");
            this.$refs.stockDialog.openEditById(row.SourceId);
            break;
          case "退货单":
            sessionStorage.setItem("check", "1");
            this.$refs.returnDialog.openEditById(row.SourceId); 
            break;
          case "费用单":
            this.$refs.costDialog.openDetailsById(row.SourceId); 
            break;
          case "其它应付单":
            this.$refs.ocostDialog.openDetailsById(row.SourceId); 
            break;
          case "委外费用单":
            console.log('委外费用单');
            break;
          case "付款单":
            this.$refs.paydocDialog.openDetailsById(row.SourceId); 
            break;
          default:
          this.$message.error("未知单据类型");
            break;
        }
      }
    }
  },
};
</script>